import { render, staticRenderFns } from "./FeedbackRejectForm.vue?vue&type=template&id=c7eab624"
import script from "./feedback-reject-form.ts?vue&type=script&lang=ts&external"
export * from "./feedback-reject-form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports